import { hashString } from '@ringba/core/utils/hash';

/**
 * Derives a stable pseudonym for a login, so the address itself never leaves the browser.
 *
 * Guarantees:
 * - `null` for an absent or blank login.
 * - Case and surrounding whitespace are normalised, so one login always yields one value.
 * - Pseudonymous, not anonymous: logins are enumerable, so anyone holding a list of candidate addresses can match them.
 */
export function hashUserLogin(login: string | null | undefined): string | null {
  const normalized = login?.trim().toLowerCase();

  return normalized ? hashString(normalized) : null;
}
